// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ProductBadgeRecyclable: React.FC<{
    size?: number;
    color1?: string;
    color2?: string;
    color3?: string;
    className?: string;
}> = ({ size = 18, color1 = "#fff", color2 = "#ccc", color3 = "#006638", className }) => (
    <svg className={className} focusable="false" viewBox="0 0 18 18" width={size} height={size}>
        <g fill="none" fillRule="evenodd">
            <rect width="18" height="18" fill={color1} rx="9" />
            <path
                fill={color2}
                fillRule="nonzero"
                d="M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0m0 .5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17"
            />
            <path
                fill={color3}
                fillRule="nonzero"
                d="M7.545 4.812C7.86 4.304 8.414 4 9 4s1.139.304 1.455.812l1.217 1.946.129-.63a.47.47 0 0 1 .552-.372.48.48 0 0 1 .366.562l-.38 1.873a.48.48 0 0 1-.224.315.46.46 0 0 1-.383.04l-1.785-.603a.477.477 0 0 1-.297-.601.47.47 0 0 1 .592-.302l.629.212-1.207-1.93A.79.79 0 0 0 9 4.952a.78.78 0 0 0-.664.37l-.42.672a.464.464 0 0 1-.637.153.48.48 0 0 1-.154-.663zm5.03 4.258a.464.464 0 0 1 .636.153l.523.837c.172.276.264.595.266.92.006.965-.762 1.75-1.711 1.75h-2.68l.485.437c.193.175.21.477.039.673a.464.464 0 0 1-.662.04l-1.407-1.27a.48.48 0 0 1-.158-.355c0-.135.057-.266.158-.355l1.407-1.27a.464.464 0 0 1 .662.04.48.48 0 0 1-.04.672l-.486.436h2.682a.78.78 0 0 0 .773-.791.8.8 0 0 0-.12-.417l-.524-.837a.48.48 0 0 1 .154-.663zm-6.087.073-.13-.65-1.3 2.077a.8.8 0 0 0-.12.417.78.78 0 0 0 .773.791h.945c.26 0 .469.213.469.477a.47.47 0 0 1-.469.476h-.945c-.95 0-1.717-.784-1.711-1.748.002-.326.094-.645.266-.92l1.273-2.039-.61.205a.465.465 0 0 1-.591-.302c-.08-.25.05-.52.297-.601l1.785-.604a.47.47 0 0 1 .607.355l.38 1.874a.468.468 0 1 1-.918.19z"
            />
        </g>
    </svg>
);

export default React.memo(ProductBadgeRecyclable);
